
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/shared/g-reviews.kpa`,
      template: `<section class="g-reviews" ref="g-reviews">
        <div class="wrapper">
            <h2>Unsere aktuellen Bewertungen</h2>
            <div id="reviews-container" ref="slider">
                {{ consentMessage }}
            </div>
        </div>
    </section>`,
      style: `g-reviews .g-reviews {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #64c16c;
}
g-reviews .g-reviews > .wrapper {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  max-width: 1568px;
  padding: 64px;
}
g-reviews .g-reviews > .wrapper h2 {
  font-family: "Merriweather", serif;
  font-size: 2rem;
  color: #f9f9f9;
  margin: 0 0 32px 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}
g-reviews .g-reviews > .wrapper:has(.consent-message) h2 {
  margin-bottom: 64px;
}
g-reviews .g-reviews > .wrapper #reviews-container {
  position: relative;
  width: 100%;
  height: 300px;
}
g-reviews .g-reviews > .wrapper #reviews-container div.consent-message {
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 24px;
  border-radius: 8px;
  background-color: #24552a;
  color: #ffffff;
  font-family: "Merriweather", serif;
  line-height: 1.6;
}
g-reviews .g-reviews > .wrapper #reviews-container div.consent-message p {
  margin: 0;
  color: #ffffff;
}
g-reviews .g-reviews > .wrapper #reviews-container div.consent-message .consent-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
}
g-reviews .g-reviews > .wrapper #reviews-container div.consent-message a:focus-visible, g-reviews .g-reviews > .wrapper #reviews-container div.consent-message button:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 4px;
}
g-reviews .g-reviews > .wrapper #reviews-container div.consent-message button {
  color: #ffffff;
  font: inherit;
  height: auto;
  min-height: 44px;
  max-width: 100%;
  line-height: 1.5;
  white-space: normal;
  padding: 8px 16px;
  border: 1px solid #ffffff;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
}
g-reviews .g-reviews > .wrapper #reviews-container:has(.consent-message) {
  display: flex;
  align-items: center;
  height: auto;
  min-height: 300px;
}
g-reviews .g-reviews > .wrapper #reviews-container:has(.consent-message) .consent-message {
  min-height: 0;
}
g-reviews .g-reviews > .wrapper .review {
  text-decoration: none;
  display: flex;
  flex-flow: column-reverse nowrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  visibility: hidden;
  opacity: 0;
  transition: opacity 2s ease-in-out 0s, visibility 0s 2s;
}
g-reviews .g-reviews > .wrapper .review h3 {
  font-family: "Merriweather", serif;
  font-size: 1rem;
  color: #f9f9f9;
  text-align: right;
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}
g-reviews .g-reviews > .wrapper .review p {
  position: relative;
  font-family: "Merriweather", serif;
  font-size: 1.4rem;
  margin: 0 0 32px 0;
  line-height: 1.6;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}
g-reviews .g-reviews > .wrapper .review p::after {
  content: "";
  position: absolute;
  bottom: -1.6rem;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.3);
}
g-reviews .g-reviews > .wrapper .review .rating {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
g-reviews .g-reviews > .wrapper .review .rating span {
  color: #ffc107;
  font-size: 1.2rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}
g-reviews .g-reviews > .wrapper .review.active {
  visibility: visible;
  opacity: 1;
  transition: opacity 2s ease-in-out 0s, visibility 0s 0s;
}
@media (max-width: 900px) {
  g-reviews .g-reviews > .wrapper .review {
    transform: translate(-50%, 0) scale(0.8);
  }
}
@media (max-width: 600px) {
  g-reviews .g-reviews > .wrapper .review {
    transform: translate(-50%, 0) scale(0.7);
  }
}
@media (max-width: 759px) {
  g-reviews .g-reviews > .wrapper {
    padding: 64px 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {
        apiKey: 'AIzaSyCfVvR_7eZvF01dSHLrMlXVRzd7GWNBgqE',
        placeIds: {
            id: 'ChIJjxnY6DYlv0cRcSzqEEZe19U',
        },
        query: 'FASE2',
        minStarRating: 4,
        consentMessage: '<div class="consent-message"><p>Die Google-Bewertungen sind aufgrund Ihrer Datenschutzeinstellungen deaktiviert. Für die Anzeige hier auf der Website benötigen wir Ihre Zustimmung zur Kategorie „Präferenzen“.</p><div class="consent-actions"><button type="button" class="open-consent-settings">Datenschutzeinstellungen öffnen</button><a href="https://www.google.com/search?q=FASE2+K%C3%B6ln+Bewertungen" target="_blank" rel="noopener noreferrer">Bewertungen bei Google öffnen</a></div></div>',
        loadingMessage: '<div class="consent-message"><p>Die Google-Bewertungen werden geladen …</p></div>',
        errorMessage: '<div class="consent-message"><p>Die Google-Bewertungen konnten derzeit nicht geladen werden. Bitte versuchen Sie es später erneut.</p><a href="https://www.google.com/search?q=FASE2+K%C3%B6ln+Bewertungen" target="_blank" rel="noopener noreferrer">Bewertungen bei Google öffnen</a></div>',
    },
    methods: {
        getScriptUrl() {
            return \`https://maps.googleapis.com/maps/api/js?key=$-{this.apiKey}&libraries=marker,places\`;
        },
        shortenText(text, maxLength) {
            if (text.length <= maxLength)
                return text;
            let shortText = text.slice(0, maxLength);
            return shortText.slice(0, shortText.lastIndexOf(" ")) + "...";
        },
        searchPlaceByQuery(query) {
            fetch(\`https://maps.googleapis.com/maps/api/place/textsearch/json?query=$-{encodeURIComponent(query)}&key=$-{this.apiKey}\`)
                .then(response => response.json())
                .then(data => {
                if (data.results && data.results.length > 0) {
                    const placeId = data.results[0].place_id;
                    console.log('PlaceId:', placeId);
                }
                else {
                    console.log('Ort nicht gefunden');
                }
            })
                .catch(error => console.error('Fehler bei der Anfrage:', error));
        },
        getReviewsFromLocalStorage(placeId) {
            const data = localStorage.getItem(\`reviews_$-{placeId}\`);
            return data ? JSON.parse(data) : null;
        },
        saveReviewsToLocalStorage(placeId, reviews) {
            const data = {
                reviews: reviews,
                timestamp: new Date().toISOString(),
            };
            localStorage.setItem(\`reviews_$-{placeId}\`, JSON.stringify(data));
        },
        isDataFresh(timestamp) {
            const now = new Date();
            const dataDate = new Date(timestamp);
            const diffInDays = (now - dataDate) / (1000 * 3600 * 24);
            return diffInDays <= 30;
        },
        loadGoogleReviews() {
            return new Promise((resolve, reject) => {
                if (!window.koppaConsentManager?.hasConsent('preferences')) {
                    resolve();
                    return;
                }
                if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
                    console.error('Google Maps API ist nicht geladen');
                    reject('Google Maps API is not loaded');
                    return;
                }
                const placeId = this.placeIds.id;
                const storedData = this.getReviewsFromLocalStorage(placeId);
                if (storedData && this.isDataFresh(storedData.timestamp)) {
                    this.displayReviews(storedData.reviews).then(resolve).catch(reject);
                }
                else {
                    this.fetchReviewsFromApi(placeId, this.minStarRating)
                        .then(reviews => this.displayReviews(reviews))
                        .then(resolve)
                        .catch(reject);
                }
            });
        },
        fetchReviewsFromApi(placeId, minRating = 1) {
            return new Promise((resolve, reject) => {
                const request = {
                    placeId: placeId,
                    fields: ['rating', 'reviews', 'user_ratings_total'],
                };
                const service = new google.maps.places.PlacesService(document.createElement('div'));
                service.getDetails(request, (place, status) => {
                    if (!window.koppaConsentManager?.hasConsent('preferences')) {
                        resolve([]);
                        return;
                    }
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        const filteredReviews = Array.isArray(place.reviews)
                            ? place.reviews.filter(r => r.rating >= minRating)
                            : [];
                        const selectedReviews = filteredReviews.slice(0, 5);
                        if (selectedReviews.length === 0) {
                            console.warn(\`No reviews found with at least $-{minRating} stars.\`);
                        }
                        this.saveReviewsToLocalStorage(placeId, selectedReviews);
                        localStorage.setItem('place_rating_info', JSON.stringify({
                            rating: place.rating,
                            total: place.user_ratings_total,
                            timestamp: new Date().toISOString()
                        }));
                        resolve(selectedReviews);
                    }
                    else {
                        console.error('Error fetching reviews:', status);
                        reject(status);
                    }
                });
            });
        },
        displayReviews(reviews) {
            return new Promise((resolve) => {
                if (!window.koppaConsentManager?.hasConsent('preferences')) {
                    resolve();
                    return;
                }
                const reviewsContainer = $refs['g-reviews'].querySelector('#reviews-container');
                reviewsContainer.innerHTML = '';
                const fragment = document.createDocumentFragment();
                reviews.forEach(review => {
                    const reviewElement = document.createElement('a');
                    reviewElement.classList.add('review');
                    reviewElement.setAttribute('href', 'https://www.google.com/search?q=fase+2+cologne&sca_esv=60c3c609de97c445&hl=de&gl=DE&sxsrf=AHTn8zqCpUwRiMYCdyydM-i6trG8ygK2xA%3A1742640319309&ei=v5TeZ_nCEs3r7_UPyM3U2Qc&oq=FASE+2+Cologn&gs_lp=Egxnd3Mtd2l6LXNlcnAiDUZBU0UgMiBDb2xvZ24qAggAMgUQIRigATIFECEYoAFIhyFQyARY_hBwAHgCkAEBmAGyAqABmgiqAQc0LjEuMC4yuAEDyAEA-AEBmAIHoAKPBsICBBAAGEfCAg4QLhiABBjHARjLARivAcICCBAAGIAEGMsBwgIdEC4YgAQYxwEYywEYrwEYlwUY3AQY3gQY4ATYAQHCAgYQABgWGB7CAggQABgWGAoYHpgDAOIDBRIBMSBAiAYBkAYIugYGCAEQARgUkgcHMy4zLjAuMaAHkiWyBwcyLjMuMC4xuAeHBg&sclient=gws-wiz-serp');
                    reviewElement.setAttribute('target', '_blank');
                    const author = document.createElement('h3');
                    author.textContent = review.author_name;
                    const rating = document.createElement('div');
                    rating.classList.add('rating');
                    let stars = '';
                    for (let i = 0; i < review.rating; i++) {
                        stars += '<span><i class="fa-solid fa-star"></i></span>';
                    }
                    rating.innerHTML = stars;
                    const text = document.createElement('p');
                    text.textContent = this.shortenText(review.text, 250);
                    reviewElement.appendChild(author);
                    reviewElement.appendChild(rating);
                    reviewElement.appendChild(text);
                    fragment.appendChild(reviewElement);
                });
                reviewsContainer.appendChild(fragment);
                requestAnimationFrame(() => resolve());
            });
        },
        reviewRotation() {
            const reviews = $refs.slider.querySelectorAll('.review');
            if (reviews.length === 0) {
                console.warn("No reviews found.");
                return;
            }
            let currentIndex = 0;
            reviews[currentIndex].classList.add('active');
            setInterval(() => {
                reviews[currentIndex].classList.remove('active');
                currentIndex = (currentIndex + 1) % reviews.length;
                reviews[currentIndex].classList.add('active');
            }, 12000);
        },
        showReviewsMessage() {
            const container = $refs['g-reviews']?.querySelector('#reviews-container');
            if (container) {
                container.innerHTML = window.koppaConsentManager?.hasConsent('preferences')
                    ? this.errorMessage
                    : this.consentMessage;
            }
        },
        initGoogleReviews() {
            if (!window.koppaConsentManager?.hasConsent('preferences')) {
                this.showReviewsMessage();
                return;
            }
            const container = $refs['g-reviews']?.querySelector('#reviews-container');
            if (container)
                container.innerHTML = this.loadingMessage;
            this.loadGoogleReviews()
                .then(() => {
                if (window.koppaConsentManager?.hasConsent('preferences')) {
                    this.reviewRotation();
                }
            })
                .catch(error => {
                console.error('Fehler beim Laden der Bewertungen:', error);
                this.showReviewsMessage();
            });
        },
        onConsentChanged(event) {
            const { category, value } = event.detail;
            const scriptUrl = this.getScriptUrl();
            if (category !== 'preferences')
                return;
            const container = $refs['g-reviews']?.querySelector('#reviews-container');
            if (value === true && window.koppaConsentManager?.hasConsent('preferences')) {
                if (container)
                    container.innerHTML = this.loadingMessage;
                if (scriptController.getScriptStatus(scriptUrl) === "loaded") {
                    this.initGoogleReviews();
                }
                else {
                    scriptController.onEvent(scriptUrl, "onLoad", () => this.initGoogleReviews());
                    scriptController.useScript(scriptUrl, { globalVar: "google" })
                        .catch((e) => {
                        console.error("Google Script konnte nicht geladen werden:", e);
                        this.showReviewsMessage();
                    });
                }
            }
            else {
                if (container) {
                    container.innerHTML = this.consentMessage;
                }
            }
        },
    },
    events: [
        ['click', '$refs.g-reviews', function (event) {
                if (!event.target.closest('.open-consent-settings'))
                    return;
                event.preventDefault();
                consentManager.openCookieBanner();
            }],
    ],
    mounted() {
        console.log('Mounted g-reviews component');
        const scriptUrl = this.getScriptUrl();
        window.addEventListener('consentChanged', this.onConsentChanged);
        if (!window.koppaConsentManager?.hasConsent('preferences')) {
            console.warn("Consent für Präferenzen nicht erteilt – Google Reviews werden nicht geladen.");
            return;
        }
        const container = $refs['g-reviews']?.querySelector('#reviews-container');
        if (container)
            container.innerHTML = this.loadingMessage;
        if (scriptController.getScriptStatus(scriptUrl) === "loaded") {
            this.initGoogleReviews();
        }
        else {
            scriptController.onEvent(scriptUrl, "onLoad", () => this.initGoogleReviews());
            scriptController.useScript(scriptUrl, {
                globalVar: "google"
            }).catch((e) => {
                console.error("Google Script konnte nicht geladen werden:", e);
                this.showReviewsMessage();
            });
        }
    },
    destroyed() {
        window.removeEventListener('consentChanged', this.onConsentChanged);
    }
};
 })()`
    };
  